import { render, staticRenderFns } from "./CrmRelativeAll.vue?vue&type=template&id=c1280914&scoped=true&"
import script from "./CrmRelativeAll.vue?vue&type=script&lang=js&"
export * from "./CrmRelativeAll.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelativeAll.vue?vue&type=style&index=0&id=c1280914&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1280914",
  null
  
)

export default component.exports